<template lang="pug">
#ewallet.tab-pane.fade.show.active(style="border-radius: 0")
  .mb-2
    label.col-form-label {{ $t('ui.bank_ewallet') }} :
    select.form-control(v-model.trim="$v.bankId.$model")
      option(disabled="" selected="" value="") {{$t('ui.please_select_ewallet')}}
      option(v-for="ewallet in dropdownList" :value="ewallet.bank_id") {{ewallet.bank_name}}
  validation(:value="$v.bankId" :name="$t('ui.bank_ewallet')" target="SELECTEWALLET")
  .mb-2
    label.col-form-label {{ $t('ui.bank_accname') }} :
    input.form-control(type="text" ref="bankAccName" v-model.trim="$v.bankAccName.$model" @keypress="$helpers.onlyAlphabet" @paste.prevent)
  validation(:value="$v.bankAccName" :name="$t('ui.bank_accname')" target="EWALLETNAME")
  .mb-2
    label.col-form-label {{ $t('ui.bank_accno') }} :
    .input-group.flex-nowrap
      span.input-group-text.btns.s2#addon-wrapping 09
      input.form-control(type="text" maxlength="9" v-model.trim="$v.bankAccNumber.$model" @keypress="$helpers.onlyNumber" @paste.prevent)
    //- .mb-2.d-flex.justify-content-between
      .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.prefix 09
      input.form-control(type="text" maxlength="9" v-model.trim="$v.bankAccNumber.$model" @keypress="$helpers.onlyNumber" @paste.prevent)
  validation(:value="$v.bankAccNumber" :name="$t('ui.bank_accno')" target="EWALLETNO")
  //- .mb-2
    label.col-form-label {{ $t('ui.tac_code') }} :
    .input-group.flex-nowrap
      input.form-control(type="text" autocomplete="off" ref="tacCodeBank" v-model.trim="$v.tacCodeBank.$model" @keypress="$helpers.onlyNumber")
      .input-group-text.btns.s2.pointer#addon-wrapping(@click="memberBankTac") {{ $t("ui.request_again") }}
    //- .d-flex
      input.form-control.w-75(type="text" autocomplete="off" ref="tacCodeBank" v-model.trim="$v.tacCodeBank.$model" @keypress="$helpers.onlyNumber")
      .countdown.w-25.pointer(@click="memberBankTac")
        span.timer.text-center {{ $t("ui.request_again") }}
  //- validation(:value="$v.tacCodeBank" :name="$t('ui.tac_code')" target="BANKTAC")
  activeDisplay(:displayType="'EWALLET'")
  .mt-4.text-center
    button.btn-submit.text-uppercase(v-if="!loading" type='button' @click.stop="memberAddEwallet") {{ $t('ui.save') }}
    button.btn-submit.disabled-grey(v-else type='button')
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import { required, helpers, minLength, maxLength } from 'vuelidate/lib/validators'
import validation from "@/library/_validation.vue"
import activeDisplay from '@/component/_activeList.vue'
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-zA-Z ]*$/);
const numericNoSpace = helpers.regex("numericNoSpace", /^[0-9]*$/);
export default {
  components: {
    validation,
    activeDisplay
  },
  props: {
    dropdownList: {
      type: Array,
      default: []
    },
  },
  data(){
    return{
      bankAccName: "",
      bankAccNumber: null,
      bankId:"",
      // bankList: [],
      // tacCodeBank: "",
      feedback:{
        success: true,
        status:""
      },
      // tacTimer: null,
      // tacCountDown: false,
      // tacDisplay: "",
      isDefault:false,
      loading: false
    }
  },
  validations() {
    return {
      bankAccName:{
        required,
        alphaNumWithSpace
      },
      bankAccNumber:{
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
        numericNoSpace
      },
      bankId:{
        required
      },
      // tacCodeBank:{
      //   required
      // }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    // getBankListing() {
    //   return this.$store.getters.bankList
    // },
  },
  created(){
    
  },
  beforeDestroy(){
    this.reset()
  },
  mounted(){
    // if(this.$store.getters.isLoggedIn){
    //   this.getBankList()
    // }
  },
  methods:{
    // memberBankTac() {
    //   let account_id = this.accountID
    //   let auth_token = this.sessionToken
    //   this.$store
    //     .dispatch("user/memberBankTac", { account_id, auth_token })
    //     .then(response => {
    //       if (response.success == true) {
    //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
    //       } else {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
    //         }
    //       }
    //     })
    //     .catch(response => {
    //       if((typeof response.status) != 'object'){
    //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
    //       }
    //     })
    // },
    memberAddEwallet(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        if(this.sessionToken) {
          let account_id = this.accountID
          let bank_id = this.bankId
          let bank_name = (this.dropdownList.filter(item => item.bank_id === this.bankId))[0].bank_name
          let bank_acc_holder = this.bankAccName
          let bank_acc_no = this.bankAccNumber
          // let tac_code = this.tacCodeBank
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/memberAddEwalletv2", { account_id, bank_id, bank_name, bank_acc_holder, bank_acc_no, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.add_wallet_success"), "success", this)
                this.reset()
                this.getMemberEwallet()
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            })
        }
      }
    },
    getMemberEwallet(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberEwallet", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    reset(){
      this.bankAccName = ""
      this.bankAccNumber = ""
      // this.tacCodeBank = ""
      this.isDefault = false
      // this.tacCodeBank = "",
      this.bankId = ""
      this.$v.$reset()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
  